import dynamic from 'next/dynamic'

export const ReviewCarousel = dynamic(() => import('./review-carousel'))
